module.exports = __webpack_public_path__ + "img/7.289d4673.png";